var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrigamiLilies(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61,
    height: 42.324,
    viewBox: "0 0 61 42.324",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_x0020_1",
    transform: "translate(-9.02 -13.226)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2540753684224",
    transform: "translate(9.52 13.96)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_297",
    "data-name": "Path 297",
    d: "M230.174,13.96a30,30,0,0,1-.184,40.856,30,30,0,0,1,.184-40.856Z",
    transform: "translate(-200.082 -13.96)",
    fill: "none",
    stroke: "#b9b1b4",
    strokeMiterlimit: 22.926,
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_158",
    "data-name": "Group 158",
    transform: "translate(0 10.854)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_298",
    "data-name": "Path 298",
    d: "M329.75,118.97a30,30,0,0,1-30,30A30,30,0,0,1,329.75,118.97Z",
    transform: "translate(-269.75 -118.97)",
    fill: "none",
    stroke: "#b9b1b4",
    strokeMiterlimit: 22.926,
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_299",
    "data-name": "Path 299",
    d: "M39.52,148.97a30,30,0,0,1-30-30A30,30,0,0,1,39.52,148.97Z",
    transform: "translate(-9.52 -118.97)",
    fill: "none",
    stroke: "#b9b1b4",
    strokeMiterlimit: 22.926,
    strokeWidth: 1,
    fillRule: "evenodd"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrigamiLilies);
export default __webpack_public_path__ + "static/media/origami-lilies.61b2b406e51bb3df03a054b08884ccde.svg";
export { ForwardRef as ReactComponent };